export enum CarrierServicePreference {
  'FAST' = 'fast',
  'CHEAP' = 'cheap',
  'CUSTOM' = 'custom',
}
